import COUNTRIES from '../countries'
import { TIocCode } from './types'

type FlagSprite = (typeof COUNTRIES)[number]['flagSpriteCoordinates']
type FlagDictionary = Record<TIocCode, FlagSprite>

/**
 * A mapping of all the country flags, keyed by IOC code. Each definition contains the sprite image coordinates.
 */
const flags: FlagDictionary = COUNTRIES.reduce((flags: FlagDictionary, { iocCode, flagSpriteCoordinates }) => {
    flags[iocCode] = flagSpriteCoordinates

    return flags
}, {} as FlagDictionary)

export default flags
